
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/telegram",
      function () {
        return require("private-next-pages/android/local/telegram/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/telegram"])
      });
    }
  